export const PRIMARY = 'rgb(11, 90, 240)';
export const ACCENT_GREEN = '#16a34a';
export const EASE_OUT_QUINT = [0.22, 1, 0.36, 1] as const;
export const EASE_MATERIAL = [0.4, 0, 0.2, 1] as const;
